import { numericPattern } from '@paid-ui/regexps/numeric';

/**
 * Format numeric string based on format template.
 *
 * @param value - Numeric string.
 * @param template - Formatter template.
 * @param separator - Separator of format template.
 * @returns Formatted numeric string.
 */
export function formatNumeric(value?: string, template?: string, separator?: RegExp) {
  if (!value || !numericPattern.test(value) || !template) {
    return value;
  }

  let lastIndex = 0;
  const result = [...template];

  for (const char of value.replace(separator ?? / /g, '')) {
    if (char === '+' && result[0] === '+') continue;

    const index = result.indexOf('#');

    if (index !== -1) {
      result[index] = char;
      lastIndex = index;
    }
  }

  return result.join('').slice(0, Math.max(0, lastIndex + 1));
}

export function ordinal(n: number): string {
  if (!Number.isInteger(n)) {
    throw new TypeError('Input must be an integer.');
  }
  let suffix: string;
  const sign = n < 0 ? '-' : '';
  const absN = Math.abs(n);
  if (absN % 100 >= 10 && absN % 100 <= 13) {
    suffix = 'th';
  } else {
    switch (absN % 10) {
      case 1: {
        suffix = 'st';
        break;
      }
      case 2: {
        suffix = 'nd';
        break;
      }
      case 3: {
        suffix = 'rd';
        break;
      }
      default: {
        suffix = 'th';
      }
    }
  }

  return `${sign}${absN}${suffix}`;
}
